"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/List/SectionHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





const MeetingsListSectionHeader = ({ label }) => (
  _react2.default.createElement('div', { className: "meeting-rooms--rooms-list--section-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 8}}
    ,  label 
  )
)

exports. default = MeetingsListSectionHeader
